import React, { useContext, useEffect, useRef, useState } from "react";
import "../css/layout.css";
import css from "../Modulecss/Home.module.css";
import axios from "axios";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Rightcontainer from "../Components/Rightcontainer";
import { useDispatch } from "react-redux";
import BetCard from "./BetCard";
import RunningCard from "./RunningCard";
import Header from "../Components/Header";
import io from "../Components/socket";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import guidebutton from "../../assets/images/guidebutton.png";
import socket from "../Components/socket";
import acceptSound from "./accept.mp3";
import findGif from "../css/loading_old.gif";
import playSound from "./accept.mp3";
import { MdOutlineDelete } from "react-icons/md";
import { FiRefreshCcw } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";
import { FaTrash } from "react-icons/fa";

export default function Homepage({ rungame, homePlay, users }) {
  // BASE URL

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  // +++++++++++++++++++++++++++++
  const history = useHistory();
  let userID = useRef();
  const isMounted = useRef(true);
  let str;

  const [user, setUser] = useState();
  const [create, setCreated] = useState([]);
  const [challangeReqRun, setChallangeReqRun] = useState(false);

  const [game_amount, setGame_amt] = useState();

  const [gameData, setGameData] = useState({});

  const [submitProcess, setProcess] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);
  const userId = localStorage.getItem("userId");
  const access_token = localStorage.getItem("token");
  const [disable, setDisable] = React.useState(challangeReqRun);
  const [disable_play, setDisable_play] = React.useState(false);
  const [GameList, setGameList] = useState(homePlay);
  // console.log(addCaseSetting?.betLimitMin,"addCaseSetting")

  const req_chall_fun = (allgameId) => {
    getPost(allgameId);
  };

  const disablebtn = (id) => {
    setDisable(true);
    setTimeout(() => {
      setDisable(false);
    }, 10000);
    //  sendMessage()
  };

  const disable_play_btn = () => {
    setDisable_play(true);
    setTimeout(() => {
      setDisable_play(false);
    }, 3000);
    // status_fun()
  };

  /// user details end

  const [game_type, setGame_type] = useState(
    useLocation().pathname.split("/")[2],
  );
  const [game_type2, setGame_type2] = useState(
    useLocation().pathname.split("/")[3],
  );
  const [Game_Ammount, setGame_Ammount] = useState("");

  const ChallengeCreate = async (e) => {
    setIsloading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (game_type == "ludoClassicManual") {
      if (Game_Ammount >= addCaseSetting?.betLimitMin && Game_Ammount <= addCaseSetting?.betLimitMax) {
        try {
          const res = await apiRequest(
            `challange/create`,
            "POST",
            { Game_Ammount, Game_type: game_type },
            headers,
          );
          setGame_amt(res?.data?.data?.Game_Ammount);

          if (res.data.status == false) {
            setIsloading(false);
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "you have already enrolled") {
            setIsloading(false);
            Swal.fire({
              title: "You have already enrolled",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "You can set maximum 2 battle.") {
            setIsloading(false);
            Swal.fire({
              title: "You can set maximum 2 battle.",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Insufficient balance") {
            setIsloading(false);
            Swal.fire({
              title: "Insufficient balance",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (
            res.data.msg ===
            "Game amount should be Greater then 50 and less then 50000"
          ) {
            setIsloading(false);
            Swal.fire({
              title:
                `Please Amount should be greater ${addCaseSetting?.betLimitMin} and less ${addCaseSetting?.betLimitMax}!`,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Set Battle in denomination of 50") {
            setIsloading(false);
            Swal.fire({
              title: "Set Battle in denomination of 50",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Technical Issue, Try after an hour!") {
            setIsloading(false);
            Swal.fire({
              title: "Technical Issue, Try after an hour!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            setIsloading(false);
          }
        } catch (e) {
          setIsloading(false);
          if (e?.response?.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("token");
            window.location.reload();
            setTimeout(() => {
              //  history.push("/login")
            }, 500);
          }
          if (e?.response?.status == 400 || e?.response?.status == 429) {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
          console.log(e);
        }
      } else {
        setIsloading(false);
        Swal.fire({
          title: `Please Amount should be greater ${addCaseSetting?.betLimitMin} and less ${addCaseSetting?.betLimitMax}!`,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else if (game_type == "ludoClassicRich") {
      if (Game_Ammount >= 550 && Game_Ammount <= 200000) {
        try {
          const res = await apiRequest(
            `challange/create`,
            "POST",
            { Game_Ammount, Game_type: game_type },
            headers,
          );
          setGame_amt(res?.data?.data?.Game_Ammount);

          if (res.data.status == false) {
            setIsloading(false);
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "you have already enrolled") {
            setIsloading(false);
            Swal.fire({
              title: "You have already enrolled",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "You can set maximum 2 battle.") {
            setIsloading(false);
            Swal.fire({
              title: "You can set maximum 2 battle.",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Insufficient balance") {
            setIsloading(false);
            Swal.fire({
              title: "Insufficient balance",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (
            res.data.msg ===
            "Game amount should be Greater then 50 and less then 50000"
          ) {
            setIsloading(false);
            Swal.fire({
              title:
                "Game amount should be Greater then 50 and less then 50000",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Set Battle in denomination of 50") {
            setIsloading(false);
            Swal.fire({
              title: "Set Battle in denomination of 50",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else if (res.data.msg === "Technical Issue, Try after an hour!") {
            setIsloading(false);
            Swal.fire({
              title: "Technical Issue, Try after an hour!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            setIsloading(false);
          }
        } catch (e) {
          setIsloading(false);
          if (e?.response?.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("token");
            window.location.reload();
            setTimeout(() => {
              //  history.push("/login")
            }, 500);
          }
          if (e?.response?.status == 400 || e?.response?.status == 429) {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
          console.log(e);
        }
      } else {
        setIsloading(false);
        Swal.fire({
          title: "Please Amount should be greater 550 and less 200000!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } else {
      try {
        const res = await apiRequest(
          `challange/create`,
          "POST",
          { Game_Ammount, Game_type: game_type },
          headers,
        );

        setGame_amt(res?.data?.data?.Game_Ammount);

        if (res.data.status == false) {
          setIsloading(false);
          Swal.fire({
            title: res.data.msg,
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "you have already enrolled") {
          setIsloading(false);
          Swal.fire({
            title: "You have already enrolled",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "You can set maximum 2 battle.") {
          setIsloading(false);
          Swal.fire({
            title: "You can set maximum 2 battle.",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Insufficient balance") {
          setIsloading(false);
          Swal.fire({
            title: "Insufficient balance",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (
          res.data.msg ===
          "Game amount should be Greater then 50 and less then 50000"
        ) {
          setIsloading(false);
          Swal.fire({
            title: "Game amount should be Greater then 50 and less then 50000",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Set Battle in denomination of 50") {
          setIsloading(false);
          Swal.fire({
            title: "Set Battle in denomination of 50",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else if (res.data.msg === "Technical Issue, Try after an hour!") {
          setIsloading(false);
          Swal.fire({
            title: "Technical Issue, Try after an hour!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        } else {
          setIsloading(false);
        }
      } catch (e) {
        setIsloading(false);
        if (e?.response?.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("token");
          window.location.reload();
          setTimeout(() => {
            //  history.push("/login")
          }, 500);
        }
        if (e?.response?.status == 400 || e?.response?.status == 429) {
          Swal.fire({
            title: "Please refresh!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
        console.log(e);
        // });
      }
    }
  };

  //open bat

  const [MyopenBattle, setMyOpenBattle] = useState([]);
  const [OtheropenBattle, setOtherMyOpenBattle] = useState([]);
  const [MyrunningBattle, setMyRunningBattle] = useState([]);
  const [OtherrunningBattle, setOtherRunningBattle] = useState([]);

  useEffect(() => {
    socket.emit("getgamelist", userId);
    socket.on("setGamelist", (data) => {
      setGameList(data);
    });
  }, []);

  useEffect(() => {
    io.on("gameCreate", (data) => {
      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyopenBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtheropenBattle.some((item) => item._id === data._id)) {
          setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
        }
      }
    });
    io.on("deletebat", (data) => {
      // Log the _id values in the MyopenBattle array
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item._id !== data,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item._id !== data,
        );
        return updatedOtheropenBattle;
      });
    });

    io.on("gameUpdate", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedOtheropenBattle;
      });
      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyopenBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtheropenBattle.some((item) => item._id === data._id)) {
          setOtherMyOpenBattle((OtheropenBattle) => [data, ...OtheropenBattle]);
        }
      }
    });

    io.on("startAccepted", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedOtheropenBattle;
      });

      if (data.Status === "running" && data?.Created_by?._id === userId) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      } else if (
        data.Status === "running" &&
        data?.Accepetd_By?._id === userId
      ) {
        if (!MyopenBattle?.some((item) => item?._id === data?._id)) {
          setMyOpenBattle((MyopenBattle) => [...MyopenBattle, data]);
        }
      } else {
        if (!OtherrunningBattle?.some((item) => item?._id === data?._id)) {
          setOtherRunningBattle((OtherrunningBattle) => [
            data,
            ...OtherrunningBattle,
          ]);
        }
      }
    });

    io.on("acceptor_seen_game", (data) => {
      // debugger
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle?.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedOtheropenBattle;
      });

      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      }
    });
    io.on("challangeAccept", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item._id !== data._id,
        );
        return updatedMyOpenBattle;
      });
      setOtherMyOpenBattle((OtheropenBattle) => {
        const updatedOtheropenBattle = OtheropenBattle?.filter(
          (item) => item._id !== data._id,
        );
        return updatedOtheropenBattle;
      });

      if (
        data?.Accepetd_By?._id === userId ||
        data?.Created_by?._id === userId
      ) {
        if (!MyrunningBattle.some((item) => item._id === data._id)) {
          setMyOpenBattle((MyrunningBattle) => [...MyrunningBattle, data]);
        }
      }
    });
  }, [io]);

  function winnAmount(gameAmount) {
    let profit = null;
    // {console.log(addCaseSetting?.commissionRange2)}
    if (gameAmount >= 50 && gameAmount <= 250)
      profit = (gameAmount * addCaseSetting?.commissionRange1) / 100;
    else if (gameAmount > 250 && gameAmount <= 500)
      profit = addCaseSetting?.commissionRange2;
    else if (gameAmount > 500)
      profit = (gameAmount * addCaseSetting?.commissionRange3) / 100;
    return gameAmount - profit;
  }

  useEffect(() => {
    // walletUpdate();
    let owenedCreated = [];
    let remainingGame = [];

    GameList?.openBattle?.forEach(function (ele) {
      if (ele)
        if (
          (ele?.Created_by?._id == userId || ele?.Accepetd_By?._id == userId) &&
          (ele?.Status == "new" || ele?.Status == "requested")
        ) {
          owenedCreated.push(ele);
        } else if (ele?.Status == "new") {
          remainingGame.push(ele);
        } else if (
          ele?.Status == "running" &&
          ele?.Accepetd_By?._id == userId &&
          ele?.Acceptor_seen === false
        ) {
          owenedCreated.push(ele);
        }
    });
    setMyOpenBattle(owenedCreated);
    setOtherMyOpenBattle(remainingGame);
    let owenedRunning = [];
    let remainingRunning = [];
    GameList?.runningBattle?.forEach(function (ele) {
      if (ele.Created_by && ele.Accepetd_By)
        if (ele.Created_by?._id == userId || ele.Accepetd_By?._id == userId) {
          owenedRunning.push(ele);
        } else {
          remainingRunning.push(ele);
        }
    });
    setMyRunningBattle(owenedRunning);

    setOtherRunningBattle(remainingRunning);
    // walletUpdate();
  }, [GameList]);

  useEffect(() => {
    io.on("resultUpdateReq1", (data) => {
      setMyOpenBattle((MyopenBattle) => {
        const updatedMyOpenBattle = MyopenBattle?.filter(
          (item) => item?._id !== data?._id,
        );
        return updatedMyOpenBattle;
      });

      if (data.Status === "cancelled" || data.Status === "completed") {
        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedowenedRunning;
        });
        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          return updatedrunningGames;
        });
      } else {
        // Check if the user's ID matches Created_by or Accepted_By
        const isUserOwned =
          data?.Created_by?._id === userId || data?.Accepetd_By?._id === userId;

        setMyRunningBattle((MyrunningBattle) => {
          const updatedowenedRunning = MyrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          if (isUserOwned) {
            updatedowenedRunning.push(data);
          }
          return updatedowenedRunning;
        });

        setOtherRunningBattle((OtherrunningBattle) => {
          const updatedrunningGames = OtherrunningBattle?.filter(
            (item) => item?._id !== data?._id,
          );
          if (!isUserOwned) {
            updatedrunningGames.push(data);
          }
          return updatedrunningGames;
        });
      }
    });
  }, [io, userId]);

  // useEffect(() => {
  //   io.on("resultUpdateReq1", (data) => {
  //     setMyOpenBattle((MyopenBattle) => {
  //       const updatedMyOpenBattle = MyopenBattle?.filter(
  //         (item) => item?._id !== data?._id
  //       );
  //       return updatedMyOpenBattle;
  //     });
  //     let owenedRunning = [];
  //     let remainingRunning = [];
  //     if (data.Status == "cancelled" || data.Status == "completed") {
  //       setMyRunningBattle((MyrunningBattle) => {
  //         const updatedowenedRunning = MyrunningBattle?.filter(
  //           (item) => item?._id !== data?._id
  //         );
  //         return updatedowenedRunning;
  //       });
  //       setOtherRunningBattle((OtherrunningBattle) => {
  //         const updatedrunningGames = OtherrunningBattle?.filter(
  //           (item) => item?._id !== data?._id
  //         );
  //         return updatedrunningGames;
  //       });
  //     } else {
  //       if (data?.Created_by && data?.Accepetd_By)
  //         if (
  //           data?.Created_by?._id == userId ||
  //           data?.Accepetd_By?._id == userId
  //         ) {
  //           owenedRunning.push(data);
  //         } else {
  //           remainingRunning.push(data);
  //         }
  //       // });
  //       setMyRunningBattle(owenedRunning);
  //       setOtherRunningBattle(remainingRunning);
  //     }
  //   });
  // }, [io]);

  useEffect(() => {
    let access_token = localStorage.getItem("token");
    access_token = localStorage.getItem("token");
    if (!access_token) {
      window.location.reload();
      setTimeout(() => {}, 500);
    }

    return () => {
      // role();
    };
  }, []);

  const RunningGames = async () => {
    const access_tokena = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/running/all`,
        "GET",
        null,
        headers,
      );
      // setRunGames(res.data)
      let owenedRunning = [];
      let remainingRunning = [];
      res?.data?.forEach(function (ele) {
        if (ele.Created_by && ele.Accepetd_By)
          if (ele.Created_by?._id == userId || ele.Accepetd_By?._id == userId) {
            owenedRunning.push(ele);
          } else {
            remainingRunning.push(ele);
          }
      });
      setMyRunningBattle(owenedRunning);
      setOtherRunningBattle(remainingRunning);
    } catch (e) {
      console.log("errror", e);
    }

    // .then((res) => {

    // })
    // .catch((e) => {
    //   console.log("errror", e);
    // });
  };

  //accept Challange

  const AcceptChallang = async (id) => {
    if (str == 1) {
      Swal.fire({
        title: "Other request in process",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
    str = 1;
    const access_token = localStorage.getItem("token");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/accept/${id}`,
        "PUT",
        { Accepetd_By: headers, Acceptor_by_Creator_at: Date.now() },
        headers,
      );
      setGameData({
        accept_by: res.data.Accepetd_By,
        created_by: res.data.Created_by,
      });

      str = 0;
      if (res.data.status === false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "you have already enrolled") {
        Swal.fire({
          title: "You have already enrolled",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "Insufficient balance") {
        Swal.fire({
          title: "Insufficient balance",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (res.data.msg === "Game already start with other player") {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      console.log(e);
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {}, 500);
      }
      if (e.response.status == 400) {
        Swal.fire({
          title: e.response.data,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      if (e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  //reject Game
  const RejectGame = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/reject/${id}`,
        "PUT",
        { Accepetd_By: null, Status: "new", Acceptor_by_Creator_at: null },
        headers,
      );
      if (res) {
        // io.emit("gameRejected");
      }
    } catch (e) {
      console.log(e);
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {
          //  history.push("/login")
        }, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  //delete

  const deleteChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/delete/${_id}`,
        "DELETE",
        null,
        headers,
      );
      if (res.data.status == false) {
        Swal.fire({
          title: res.data.msg,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      if (e?.response?.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {
          //  history.push("/login")
        }, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    }
  };

  ///challange/running/update/

  const updateChallenge = async (_id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `challange/running/update/${_id}`,
        "PUT",
        { Acceptor_seen: true },
        headers,
      );
      if (res) {
        localStorage.setItem("timeOver", "timeStart");
        // io.emit("game_seen");
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        setTimeout(() => {
          //  history.push("/login")
        }, 500);
      }
      if (e.response.status == 400 || e.response.status == 429) {
        Swal.fire({
          title: "Please refresh!",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
      console.log(e);
    }
  };

  const getPost = async (Id) => {
    if (
      game_type === "Ludo Classics" ||
      game_type === "Ludo 1 Goti" ||
      game_type === "Ludo Ulta" ||
      game_type === "Prime Ludo" ||
      game_type === "Ludo Host"
    ) {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);

        const access_token = localStorage.getItem("token");

        const headers = {
          authorization: `Bearer ${access_token}`,
        };

        try {
          const res = await apiRequest(
            `challange/requested/running/${game_type}/` + Id,
            "PATCH",
            null,
            headers,
          );
          setProcess(true);
          setChallangeReqRun(false);
          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            history.push(`/viewgame1/${Id}`, {
              prevPath: window.location?.pathname,
            });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          if (e?.response?.status == 401) {
            Swal.fire({
              title: "Somthing wrong",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }
      }
    } else if (
      game_type === "LudoSnake" ||
      game_type === "LudoPopular" ||
      game_type === "ludoClassicManual" ||
      game_type === "ludoClassicRich"
    ) {
      if (submitProcess) {
        setProcess(false);
        setChallangeReqRun(true);

        const access_token = localStorage.getItem("token");

        const headers = {
          authorization: `Bearer ${access_token}`,
        };

        try {
          const res = await apiRequest(
            "challange/requested/running/" + Id,
            "PATCH",
            {},
            headers,
          );
          setProcess(true);
          setChallangeReqRun(false);

          if (res.data.status == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            history.push(`/viewgame1/${Id}`, {
              prevPath: window.location?.pathname,
            });
          }
        } catch (e) {
          setProcess(true);
          setChallangeReqRun(false);
          if (e?.response?.status == 401) {
            Swal.fire({
              title: "Somthing wrong",
              icon: "warning",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: "Please refresh!",
              icon: "warning",
              confirmButtonText: "OK",
            });
          }
        }
      }
    }
  };

  const handleButtonClick = (gameType) => {
    setGame_type(gameType);
  };
  // Socket for GameModeChange list

  const GameModeChange = () => {
    socket.on("setGamelist", (modeData) => {
      setGameList(modeData);
    });
  };
  useEffect(() => {
    // RunningGames()
  }, []);

  // language
  const translations = {
    hi: {
      gameadd: "गेम बनाये !",
      gameset: "लगाये",
      openGame: "खुला गेम ",
      challange: "चुनोती देने वाला  ",
      entry: "प्रवेश शुल्क",
      prize: "इनाम",
      play: "खेले ",
      running: "चल रहे गेम ",
      start: "चालू",
      cancel: "रद्द करें",
    },
    en: {
      gameadd: "Create a Battle!",
      gameset: "Set",
      openGame: "Open Battles",
      challange: "Challange From  ",
      entry: "Entry Fee ",
      prize: "winning Prize  ",
      play: "Play",
      running: "Running Battles",
      start: "Start",
      cancel: "Decline",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  // change theme
  // const theme1 = localStorage.getItem("theme");
  // let theme = "";
  // if (theme1 == "dark") {
  //   theme = "light";
  // } else {
  //   theme = "dark";
  // }
  const theme = localStorage.getItem("theme");
  const styles = {
    backgroundColor: theme === "light" ? "#d3e3fd" : "black",
    color: theme === "light" ? "black" : "#fff",
  };
  const styles1 = {
    backgroundColor: theme === "light" ? "#000" : "green",
    color: theme === "light" ? "black" : "#fff",
  };
  const styles3 = {
    backgroundColor: theme === "light" ? "rgb(38, 53, 93)" : "#27241b",
    color: theme === "light" ? "#fff" : "#fff",
  };

  const backgroundColor = theme === "light" ? "#fff" : "#333 !important";

  return (
    <>
      <Header user={users} />
      <div className="leftContainer mb_space " style={styles}>
        <div className="pt-3 mt-5   Orher_page_main_section" style={styles}>
          {/* {game_type === "ludoClassicManual" ||
          game_type === "ludoClassicRich" ? (
            <div className="modeButton">
              <Link
                to="ludoClassicManual"
                className={`game_tabs_btn mb-3  ${
                  game_type === "ludoClassicManual" ? "active" : ""
                }`}
                onClick={() => {
                  handleButtonClick("ludoClassicManual");
                  GameModeChange();
                }}
              >
                Lite Mode (50 - 500)
              </Link>
              <Link
                to="ludoClassicRich"
                className={`game_tabs_btn mb-3 ml-2 ${
                  game_type === "ludoClassicRich" ? "active" : ""
                }`}
                onClick={() => {
                  handleButtonClick("ludoClassicRich");
                  GameModeChange();
                }}
              >
                 Rich Mode (550 - 200000)
              </Link>
            </div>
          ) : (
            ""
          )} */}

          {/* <div style={styles3}>
            <div className="alrt_msg_div" styles={styles3}>
              {game_type === "LudoSnake" ? (
                <h5 className="" styles={styles3}>
                  {JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                    ? ""
                    : JSON.parse(localStorage.getItem("sitSetting"))
                      ?.ludoClassicManualMsg}
                </h5>
              ) : (
                <h5 className="" styles={styles3}>
                  {JSON.parse(localStorage.getItem("sitSetting")) == "undefined"
                    ? ""
                    : JSON.parse(localStorage.getItem("sitSetting"))
                      ?.ludoClassicAutoMsg}
                </h5>
              )}
            </div>
          </div> */}

          {(() => {
            const sitSettingRaw = localStorage.getItem("sitSetting");

            if (!sitSettingRaw || sitSettingRaw === "undefined") return null;

            const sitSetting = JSON.parse(sitSettingRaw);
            const manualMsg = sitSetting?.ludoClassicManualMsg;
            const autoMsg = sitSetting?.ludoClassicAutoMsg;

            const showMessage = game_type === "LudoSnake" ? manualMsg : autoMsg;

            if (!showMessage) return null;

            return (
              <div style={styles3}>
                <div className="alrt_msg_div" style={styles3}>
                  <h5 className="">{showMessage}</h5>
                </div>
              </div>
            );
          })()}

          <div>
            {/* Create a Battle */}

            {JSON.parse(localStorage.getItem("sitSetting")) == "undefined" ? (
              ""
            ) : JSON.parse(localStorage.getItem("sitSetting"))?.gameSearch ==
              true ? (
              <>
                <div className="battel-bx position-relative">
                  <span className="other_page_small_headings text-dark">
                    {translations[language].gameadd}
                  </span>
                  <span
                    className={`${css.gamesSectionHeadline} info text-uppercase position-absolute  font-weight-bold bg-s-1 rounded px-1 mt-0 mb-0  `}
                    style={{ right: "11px", top: "11px" }}
                  >
                    Rules
                    <NavLink to="/Rules">
                      <img
                        className="ml-2"
                        src={
                          process.env.PUBLIC_URL + "/images/Homepage/info.png"
                        }
                        alt=""
                        width="14px"
                      />
                    </NavLink>
                  </span>

                  <div className="user_reder_code_box mt-2">
                    {addCaseSetting.gameSearch && game_type2 != "new" ? (
                      <input
                        className="commaon_input_box"
                        type="tel"
                        placeholder="Enter amount"
                        value={Game_Ammount}
                        onChange={(e) => setGame_Ammount(e.target.value)}
                      />
                    ) : null}

                    <div className="set  check_btn">
                      {" "}
                      {!isLoading ? (
                        <>
                          {addCaseSetting.gameSearch && game_type2 != "new" ? (
                            <button
                              className="samll_btn_game samll_btn new_small_btn"
                              onClick={(e) => {
                                e.preventDefault();
                                setGame_Ammount("");

                                ChallengeCreate();
                              }}
                            >
                              {translations[language].gameset}
                            </button>
                          ) : null}
                        </>
                      ) : (
                        <button
                          className={`bg-green ${css.playButton} cxy m-1 position-static `}
                          disabled
                        >
                          <Spinner
                            as="span"
                            animation="grow"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                          Loading...
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            <div className="py-3">
              <div className="mb-3 open_battle_headings">
                <img
                  src={process.env.PUBLIC_URL + "/images/crossswords.png"}
                  alt=""
                  width="30px"
                />
                <span
                  className={`ml-2 ${css.gamesSectionTitle} games_Section_Title`}
                >
                  {translations[language].openGame}
                </span>
                {/* yOUTUBE LINK */}
                {/* {game_type === "ludoClassicManual" ? (
                  <a
                    href="https://youtu.be/pSPw5mJ7dv8?si=x9Lk24nEgfHoiX2T"
                    target="_blank"
                    className={`${css.gamesSectionHeadline} text-uppercase position-absolute mt-2 font-weight-bold auto_youtbe`}
                    style={{
                      right: "6.5rem",
                      backgroundColor: "#003441",
                      color: "white",
                      borderRadius: "4px",
                      padding: "4px 13px",
                      fontSize: "12px",
                    }}
                  >
                    Youtube
                    <img
                      className="ml-2"
                      src={"/images/Homepage/youtube.png"}
                      alt=""
                      width="16px"
                    />
                  </a>
                ) : (
                  <a
                    href="https://youtu.be/Y1fSSOvRUxU?si=9AEAdDuiJOPIvhSO"
                    target="_blank"
                    className={`${css.gamesSectionHeadline} text-uppercase position-absolute mt-2 font-weight-bold auto_youtbe`}
                    style={{
                      right: "6.5rem",
                      backgroundColor: "#003441",
                      color: "white",
                      borderRadius: "4px",
                      padding: "4px 13px",
                      fontSize: "12px",
                    }}
                  >
                    Youtube
                    <img
                      className="ml-2"
                      src={"/images/Homepage/youtube.png"}
                      alt=""
                      width="16px"
                    />
                  </a>
                )} */}
              </div>

             {MyopenBattle &&
  MyopenBattle.filter((allgame) => allgame?.Game_type === game_type).map(
    (allgame, index) => (
      <div
        key={index}
        className="box-card battle_card_main card_bottom_border mb-2"
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "10px",
          overflow: "hidden",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          border: "1px solid #e2e8f0",
          color: "#000000",
        }}
      >
        {/* Card Header */}
        <div
          className="d-flex justify-content-between align-items-center px-3 py-2"
          style={{
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          {/* Challenge Title */}
          <span style={{ fontSize: "14px", fontWeight: "700", color: "#000000" }}>
            {translations[language].challange}
          </span>

          {/* Amount Badge on Top Right */}
          <div
            className="badge-d-success px-2.5 py-1"
            style={{
              backgroundColor: "#dcfce7",
              borderRadius: "15px",
              border: "1px solid #bbf7d0",
            }}
          >
            <span
              style={{
                color: "#16a34a",
                fontSize: "13px",
                fontWeight: "700",
              }}
            >
              R <small className="s_sign">S.</small>{" "}
              <span className="S_amount">{allgame?.Game_Ammount}</span>
            </span>
          </div>
        </div>

        {/* Card Body */}
        <div
          className="d-flex align-items-center justify-content-between px-3 py-2"
        >
          {/* Creator Avatar & Name Section */}
          <div className="d-flex align-items-center">
            <div className="mr-2">
              {allgame?.Created_by?.avatar ? (
                <img
                  src={baseUrl + `${allgame?.Created_by?.avatar}`}
                  alt=""
                  width="30px"
                  height="30px"
                  style={{ borderRadius: "50%", objectFit: "cover" }}
                />
              ) : (
                <img
                  src="/images/avatars/Avatar1.png"
                  alt=""
                  width="30px"
                  height="30px"
                  style={{ borderRadius: "50%", objectFit: "cover" }}
                />
              )}
            </div>
            <span
              style={{
                color: "#000000",
                fontWeight: "600",
                fontSize: "14px",
              }}
            >
              {allgame.Created_by?.Name?.length > 10
                ? `${allgame.Created_by?.Name.slice(0, 10)}...`
                : allgame.Created_by?.Name}
            </span>
          </div>

          {/* Action Buttons Section */}
          <div className="d-flex align-items-center">
            {/* Loader for creator when status is new */}
            {userId == allgame?.Created_by?._id &&
              allgame?.Status == "new" && (
                <div className="pr-2 text-center">
                  <img
                    src="/images/LandingPage_img/loader1.gif"
                    style={{
                      width: "24px",
                      height: "24px",
                      transform: "scale(1.2)",
                    }}
                  />
                </div>
              )}

            {/* Delete Button for Creator */}
            {userId == allgame?.Created_by?._id &&
              allgame?.Status == "new" && (
                <button
                  className="delete-challenge-btn d-flex align-items-center justify-content-center btn btn-danger btn-sm"
                  onClick={() => deleteChallenge(allgame?._id)}
                  title="Delete Challenge"
                  style={{ padding: "4px 10px", borderRadius: "8px" }}
                >
                  <FaTrash size={12} />
                </button>
              )}

            {/* Play Button (for other users when status is new) */}
            {userId &&
              allgame &&
              userId !== allgame?.Created_by?._id &&
              allgame?.Status == "new" && (
                <button
                  className="btn btn-success px-4 py-1 font-weight-bold samll_btn bg-s battle_plat_btn"
                  disabled={disable_play}
                  style={{
                    backgroundColor: "#0284c7",
                    borderColor: "#0284c7",
                    borderRadius: "20px",
                    fontSize: "14px",
                    color: "#fff",
                    ...styles1,
                  }}
                  onClick={() => {
                    disable_play_btn();
                    AcceptChallang(allgame?._id);
                  }}
                >
                  {translations[language].play}
                </button>
              )}

            {/* Requested & Cancel buttons */}
            {userId !== allgame?.Created_by?._id &&
              allgame?.Status == "requested" && (
                <div className="d-flex align-items-center">
                  <div
                    className="position-relative bg-start mx-1 text-white btn-sm request_btn d-flex align-items-center justify-content-center"
                    style={{
                      backgroundColor: "#eab308",
                      borderRadius: "15px",
                      padding: "4px 10px",
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                  >
                    requested
                  </div>
                  <button
                    className="position-relative mx-1 btn btn-danger btn-sm py-1"
                    style={{
                      borderRadius: "15px",
                      padding: "4px 10px",
                      fontSize: "12px",
                    }}
                    onClick={() => RejectGame(allgame?._id)}
                  >
                    cancel
                  </button>
                </div>
              )}

            {/* Start Button (when status is running) */}
            {userId &&
              allgame &&
              userId !== allgame?.Created_by?._id &&
              allgame?.Status == "running" && (
                <div>
                  <audio src={playSound} autoPlay></audio>
                  <Link>
                    <button
                      disabled={disable}
                      className="samll_btn start_btn_color bg-s-1 py-1"
                      style={{
                        borderRadius: "20px",
                        padding: "4px 14px",
                        fontSize: "13px",
                        backgroundColor: "#16a34a",
                        color: "#fff",
                        border: "none",
                      }}
                      onClick={(e) => {
                        disablebtn();
                        updateChallenge(allgame?._id);
                        history.push(`/viewgame1/${allgame?._id}`, {
                          prevPath: window.location.pathname,
                        });
                      }}
                    >
                      {translations[language].start}
                    </button>
                  </Link>
                </div>
              )}

            {/* Creator actions when status is requested */}
            {userId &&
              allgame &&
              userId == allgame?.Created_by?._id &&
              allgame?.Status == "requested" && (
                <div className="d-flex align-items-center">
                  <audio src={acceptSound} autoPlay></audio>
                  <Link style={{ bottom: "0" }}>
                    <button
                      className="bg-start position-relative mx-1 btn-sm text-white py-1"
                      disabled={disable}
                      style={{
                        display: disable ? "none" : "block",
                        borderRadius: "20px",
                        padding: "4px 12px",
                        fontSize: "12px",
                        backgroundColor: "#16a34a",
                        border: "none",
                      }}
                      onClick={(e) => {
                        disablebtn(allgame?._id);
                        req_chall_fun(allgame?._id);
                      }}
                    >
                      {translations[language].start}
                    </button>
                    <button
                      className={
                        disable
                          ? "btn btn-primary d-block py-1"
                          : "btn btn-primary d-none"
                      }
                      style={{
                        borderRadius: "20px",
                        fontSize: "12px",
                        padding: "4px 12px",
                      }}
                    >
                      Wait
                    </button>
                  </Link>
                  <button
                    className={
                      disable
                        ? "d-none text-white bg-danger position-relative mx-1 btn-sm"
                        : "text-white position-relative mx-1 fw-bold btn btn-danger btn-sm d-block py-1"
                    }
                    onClick={() => RejectGame(allgame?._id)}
                    style={{
                      bottom: "0",
                      borderRadius: "20px",
                      padding: "4px 12px",
                      fontSize: "12px",
                    }}
                  >
                    {translations[language].cancel}
                  </button>
                </div>
              )}
          </div>
        </div>
      </div>
    )
  )}

              {OtheropenBattle &&
                OtheropenBattle?.filter(
                  (allgame) => allgame?.Game_type === game_type,
                ).map((allgame, index) => (
                  <div
                    className={`${css.betCard} mt-2 box-card  battle_card_main_div card_bottom_border`}
                  >
                    <span
                      className={`${css.betCardTitle}  d-flex align-items-center  ${css.betTitleDiv} headings ml-2 text-primary`}
                    >
                      {translations[language].challange}
                      {/* <span className="ml-1" style={{ color: "#888" }}>
                        {allgame?.Created_by?.Name}
                      </span> */}

                      <div className="ml-auto">
                        {/* <img
                          className="mx-1 mb-1"
                          src="/images/rupee.png"
                          alt=""
                          width="20x"
                          height="20x"
                        /> */}
                        <span
                          className={`${css.betCardAmount}  badge-d-success`}
                          style={{ color: "black" }}
                        >
                          RS.{allgame?.Game_Ammount}
                        </span>
                      </div>
                      {userId == allgame?.Created_by?._id &&
                        allgame?.Status == "new" && (
                          <button
                            className={`  ml-auto delete_buttons`}
                            onClick={() => deleteChallenge(allgame?._id)}
                          >
                            {/* DELETE */}
                            <MdOutlineDelete className="card_icons" />
                          </button>
                        )}
                      {userId == allgame?.Created_by?._id &&
                        allgame?.Status == "requested" && (
                          <div className="d-flex ml-auto align-items-center">
                            <Link style={{ bottom: "0" }}>
                              <button
                                className={`bg-success position-relative mx-1 btn-sm text-white btn-inverse-success`}
                                disabled={disable}
                                style={{
                                  display: disable ? "none" : "block",
                                }}
                                onClick={(e) => {
                                  disablebtn(allgame?._id);
                                  req_chall_fun(allgame?._id);
                                }}
                              >
                                {translations[language].start}
                              </button>
                              <button
                                className={
                                  disable
                                    ? "btn btn-primary d-block"
                                    : "btn btn-primary d-none"
                                }
                              >
                                Wait
                              </button>
                            </Link>
                            <button
                              className={
                                disable
                                  ? "d-none text-white bg-danger position-relative mx-1 btn-sm btn-outline-youtube"
                                  : "text-white bg-danger position-relative mx-1 btn-sm btn-outline-youtube d-block"
                              }
                              onClick={() => RejectGame(allgame?._id)}
                              style={{ bottom: "0" }}
                            >
                              {translations[language].cancel}
                            </button>
                          </div>
                        )}
                    </span>
                    <div
                      className={`  ${css.betBodyDiv} play_bottom py-2 new-space battle_card_inner_bottom`}
                    >
                      {/* Entry Fee */}
                      <div className="">
                        {/* <span className={css.betCardSubTitle}>{translations[language].entry}</span> */}
                        {/* <div>
                          <img
                            className="mx-1 mb-1"
                            src="/images/rupee.png"
                            alt=""
                            width="20x"
                            height="20x"
                          />
                          <span className={`${css.betCardAmount} text-green-light`} style={{ color: "black" }}>
                            {allgame?.Game_Ammount}
                          </span>
                        </div> */}
                        <div className="d-flex align-items-center">
                          <img class="game_media" src="/images/game_user.jpg" />
                          <b>
                            <span className="ml-1" style={{ color: "#000" }}>
                              {allgame.Created_by?.Name?.length > 5
                                ? `${allgame.Created_by?.Name?.slice(0, 5)}...`
                                : allgame.Created_by?.Name}
                            </span>
                          </b>
                        </div>
                      </div>

                      {userId &&
                        allgame &&
                        userId !== allgame?.Created_by?._id &&
                        allgame?.Status == "new" && (
                          <button
                            className={`   samll_btn bg-grndend  battle_plat_btn `}
                            disabled={disable_play}
                            style={styles1}
                            onClick={() => {
                              disable_play_btn();
                              AcceptChallang(allgame?._id);
                            }}
                          >
                            {translations[language].play}
                          </button>
                        )}
                      {userId == allgame?.Created_by?._id &&
                        allgame?.Status == "new" && (
                          <div className="pl-2 text-center">
                            <img
                              src="/images/LandingPage_img/loader1.gif"
                              style={{ width: "25px", height: "25px" }}
                            />
                          </div>
                        )}
                      {userId !== allgame?.Created_by?._id &&
                        allgame?.Status == "requested" && (
                          <div className="d-flex  align-items-center">
                            <div
                              className={`  position-relative mx-1 text-white btn-sm request_btn`}
                            >
                              requested
                            </div>
                            <button
                              className={`  position-relative mx-1 btn-sm reject_btn`}
                              onClick={() => RejectGame(allgame?._id)}
                            >
                              cancel
                            </button>
                          </div>
                        )}

                      {userId &&
                        userId !== allgame?.Created_by?._id &&
                        allgame?.Status == "running" && (
                          <div className="">
                            <audio src={playSound} autoPlay></audio>
                            <Link>
                              <button
                                disabled={disable}
                                className={`samll_btn start_btn_color'`}
                                // className={` ${css.playButton} ${css.cxy}  samll_btn '`}
                                style={{ background: "#fff" }}
                                onClick={(e) => {
                                  disablebtn();
                                  updateChallenge(allgame?._id);
                                  history.push(`/viewgame1/${allgame?._id}`, {
                                    prevPath: window.location.pathname,
                                  });
                                }}
                              >
                                {translations[language].start}
                              </button>
                            </Link>
                          </div>
                        )}
                      {userId == allgame?.Created_by?._id &&
                        allgame.Status == "requested" && (
                          <div className="">
                            <audio src={acceptSound} autoPlay></audio>

                            <div className="text-center col">
                              <div className="pl-2">
                                {allgame?.Accepetd_By?.avatar ? (
                                  <img
                                    src={
                                      baseUrl +
                                      `${allgame?.Accepetd_By?.avatar}`
                                    }
                                    alt=""
                                    width="40px"
                                    height="40px"
                                    style={{
                                      borderTopLeftRadius: "50%",
                                      borderTopRightRadius: "50%",
                                      borderBottomRightRadius: "50%",
                                      borderBottomLeftRadius: "50%",
                                      marginTop: "5px",
                                    }}
                                  />
                                ) : (
                                  <img
                                    src="/images/avatars/Avatar1.png"
                                    alt=""
                                    width="40px"
                                    height="40px"
                                    style={{
                                      borderTopLeftRadius: "50%",
                                      borderTopRightRadius: "50%",
                                      borderBottomRightRadius: "50%",
                                      borderBottomLeftRadius: "50%",
                                      marginTop: "5px",
                                    }}
                                  />
                                )}
                              </div>
                              <div style={{ lineHeight: 1 }}>
                                <span className="bet_player_name">
                                  {allgame?.Accepetd_By.Name}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}

                      {/* prize */}
                      {/* <div>
                        <span className={css.betCardSubTitle}>{translations[language].prize}</span>
                        <div>
                          <span className={`${css.betCardAmount} text-green-light`} style={{ color: "#68cad5" }}>
                            <img
                              className="mx-1 mb-1"
                              src="/images/rupee.png"
                              alt=""
                              width="20x"
                              height="20x"
                            />
                            {allgame?.Game_Ammount +
                              winnAmount(allgame?.Game_Ammount)}
                          </span>
                        </div>
                      </div> */}
                    </div>
                  </div>
                ))}
            </div>
            <div className="battle_divider"></div>
            <div className="mb-5">
              <div className="open_battle_headings">
                <img
                  src={
                    process.env.PUBLIC_URL + "/images/Homepage/battleIcon.png"
                  }
                  alt=""
                  width="20px"
                />
                <span
                  className={`ml-2  ${css.gamesSectionTitle} games_Section_Title text-white`}
                  style={{ margin: "0px", color: "white" }}
                >
                  {translations[language].running}
                </span>

                {/* <button
                  onClick={RunningGames}
                  style={{
                    backgroundColor: "transparent",
                    color: "#1b6ef3",
                    borderRadius: "4px",
                    padding: "4px 2px",
                    fontSize: "12px",
                    border: "none",
                  }}
                >
                  <FiRefreshCcw style={{ margin: "5px" }} />
                </button> */}
              </div>

              {MyrunningBattle &&
                MyrunningBattle.map((runnig) => {
                  if (
                    ((userId == runnig.Accepetd_By._id
                      ? (runnig.Status === "running" &&
                          userId == runnig.Accepetd_By._id &&
                          runnig.Acceptor_seen == true) ||
                        runnig.Status === "pending"
                      : (runnig.Status === "running" &&
                          userId == runnig.Created_by._id) ||
                        runnig.Status === "pending") ||
                      runnig.Status == "conflict") &&
                    (runnig?.Game_type == game_type ||
                      runnig?.Game_type == "ludoClassicManual" ||
                      runnig?.Game_type == "ludoClassicRich" ||
                      runnig?.Game_type == "LudoPopular")
                  )
                    return (
                      <RunningCard
                        key={runnig._id}
                        runnig={runnig}
                        user={users}
                        winnAmount={winnAmount}
                      />
                    );
                })}

              {OtherrunningBattle &&
                OtherrunningBattle.map((runnig) => {
                  if (
                    (userId == runnig?.Accepetd_By?._id ||
                    userId == runnig?.Created_by?._id
                      ? userId == runnig.Accepetd_By._id
                        ? (runnig.Status === "running" &&
                            userId == runnig.Accepetd_By._id &&
                            runnig.Acceptor_seen == true) ||
                          (runnig.Status === "pending" &&
                            runnig.Acceptor_status == null)
                        : (runnig.Status === "running" &&
                            user == runnig.Created_by._id) ||
                          (runnig.Status === "pending" &&
                            runnig.Creator_Status == null)
                      : runnig.Status === "running" ||
                        runnig.Status === "pending") &&
                    (runnig?.Game_type == game_type ||
                      game_type == "ludoClassicManual" ||
                      game_type == "ludoClassicRich")
                  )
                    return (
                      <>
                        <RunningCard
                          key={runnig._id}
                          runnig={runnig}
                          user={users}
                          winnAmount={winnAmount}
                        />
                      </>
                    );
                })}
            </div>
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}
